import React, { useState,useEffect } from 'react'
import MenuImg from './../Assets/images/menu.svg';
import Filter from './../Assets/images/filter-new.svg';
import UserIcon from './../Assets/images/user.svg';
import RatioIcon from './../Assets/images/ratio.svg';
import UserManagement from './../Assets/images/usermanagement.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Templates from '../Assets/images/templates.svg';
import LogOut from '../Assets/images/logout.svg';
import { useDispatch } from "react-redux";
import { setSelectedValues } from "../Redux/SelectedSpace"; 
import LogoutConformation from './LogoutConformation';



const AdminSidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [isLogoutModalVisible,setisLogoutModalVisible] = useState(false)
    const [userCheck, setUserCheck] = useState(false);

    useEffect(() => {
      const userId = localStorage.getItem("roles");
      setUserCheck(userId === "admin");
    }, []);

    const handleClick = () => {
      dispatch(setSelectedValues([])); 
    };

    const handleLogoutConformation = ()=>{
      setisLogoutModalVisible(true)
    }
    
    const handleLogoutModalCancel =()=>{
      setisLogoutModalVisible(false)
    }

    const handleConfirmLogout = ()=>{
      setisLogoutModalVisible(false)
      localStorage.removeItem('accessToken');
      localStorage.removeItem('adminId');
      localStorage.removeItem('firstName');
      localStorage.removeItem('roles');
  
      // Redirect to login page
      navigate('/');
  }

    

   
    return (
            

            <div className="col-size-2">
      <div
        className="inside-filter text-center pt-4"
        style={{
          width: '60px',
          padding: '5px',
        }}
      >
        <div className="">
          <a href="">
            <img src={MenuImg} alt="" style={{ width: '20px' }} />
          </a>
        </div>
        <ul className="admin-sidebar">
          <li>
            <Link title='Select Space' to="/spaceSelect/planning-to-theater"  className={location.pathname === '/spaceSelect/planning-to-theater' ? 'active' : ''}  onClick={handleClick}>
              <img src={Filter} alt=""
              style={{ 
                width: '24px',
                filter: location.pathname === '/spaceSelect/planning-to-theater' ? 'invert(100%)' : 'invert(0%)',
             }}
              />
            </Link>
          </li>
          {userCheck &&(
          <li>
            <Link title='User Management' to="/spaceSelect/user-management" className={location.pathname === '/spaceSelect/user-management' ? 'active' : ''}>
              <img src={UserManagement} alt=""
              style={{ 
                width: '23px',
                filter: location.pathname === '/spaceSelect/user-management' ? 'invert(100%)' : 'invert(0%)',
             }}
              />
            </Link>
          </li>
          )}
          <li>
            <Link title='Configuration' to="/spaceSelect/range-table"  className={location.pathname === '/spaceSelect/range-table' ? 'active' : ''}>
              <img src={RatioIcon} alt="" style={{ 
                                    width: '22px',
                                    filter: location.pathname === '/spaceSelect/range-table' ? 'invert(100%)' : 'invert(0%)',
                                 }}  />
            </Link>
          </li>
          <li>
                <Link 
                title='Saved Templates'
                to="/spaceSelect/templates"
                className={location.pathname === '/spaceSelect/templates' ? 'active' : ''}
                >
                        <div className="sidebar-icon">
                            <img src={Templates} alt="Template icon" 
                            style={{ width: '20px',
                            filter: location.pathname === '/spaceSelect/templates' ? 'invert(100%)' : 'invert(0%)',}} 
                            />
                        </div>
                      
                    </Link>
                    
                </li>
                <li>
            <Link title='Profile' to="/spaceSelect/my-profile" className={location.pathname === '/spaceSelect/my-profile' ? 'active' : ''}>
              <img src={UserIcon} alt=""
              style={{ 
                width: '19px',
                filter: location.pathname === '/spaceSelect/my-profile' ? 'invert(100%)' : 'invert(0%)',
             }}
              />
            </Link>
          </li>
                <li>
            <Link to="#" className="" title='Logout'>
              <img 
              src={LogOut}  
              onClick={handleLogoutConformation}
              title='Logout'
              alt="Logout"
              style={{ 
                width: '19px',
             }}
              />
            </Link>
          </li>
        </ul>
      </div>

      <LogoutConformation
          isVisible={isLogoutModalVisible}
          onCancel={handleLogoutModalCancel}
          onConfirm={handleConfirmLogout}
          message="Are you sure you want to logout?"
        />

    </div>

            
    )
}
export default AdminSidebar;